import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    contacts: 'Contacts',
    emptyMaxOccurenceError: 'Please provide maximum occurrences',
    frequency: 'Frequency',
    givenWeeks: 'Once per week during',
    occurence: 'Occurrence',
    once: 'Only once',
    optionTitle: 'Send reminder email in case of late payment',
    requiredContactsError:
      'Please, choose at least one contact in the list to whom Shine will send reminders',
    save: 'Save',
    sendToMyself: 'Send myself a test email',
    settingsSaved: 'Saved preferences',
    totalWeeksLabel: 'Number of weeks',
    untilPayment: 'Once per week until payment',
    weeks: 'weeks',
  },
  fr: {
    contacts: 'Contacts',
    emptyMaxOccurenceError: 'Veuiller préciser le nombre de semaines',
    frequency: 'Fréquence',
    givenWeeks: '1 fois par semaine pendant',
    occurence: 'Répétition',
    once: 'Une seule fois',
    optionTitle: 'Envoyer un e-mail de relance en cas de retard de paiement',
    requiredContactsError:
      'Pensez à choisir le ou les contacts à qui nous enverrons des relances',
    save: 'Enregistrer',
    sendToMyself: 'M’envoyer un e-mail test',
    settingsSaved: 'Préférences enregistrées',
    totalWeeksLabel: 'Nombre de semaines',
    untilPayment: '1 fois par semaine jusqu’au paiement',
    weeks: 'semaines',
  },
} as const);
